module.exports = __webpack_public_path__ + "img/logo.cb8c097d.png";